(function () {
  const downloadButton = document.getElementById('wmb-download-now-button');
  const popup = document.getElementById('wmb-download-popup');
  const closeButtons = document.querySelectorAll('[data-wmb-close]');
  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  const addToCartButton = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
  const form = document.getElementById('wmb-download-form');
  const purposeSelect = document.getElementById('wmb-purpose');
  const tagsInput = document.getElementById('wmb-customer-tags');
  const marketingCheckbox = document.getElementById('wmb-marketing');
  const marketingHidden = document.getElementById('wmb-accepts-marketing-hidden');
  const submitFrame = document.querySelector('iframe[name="wmb-hidden-submit-frame"]');
  const messageEl = document.getElementById('wmb-form-message');

  if (!downloadButton || !popup || !variantInput || !window.WMB_DOWNLOADS) return;

  if (form) {
    form.setAttribute('target', 'wmb-hidden-submit-frame');
  }

  // --- Geo-based consent checkbox default ---
  const STRICT_CONSENT_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
    'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
    'NO','IS','LI',
    'GB','CH','CA'
  ];

  function applyGeoConsentDefault() {
    if (!marketingCheckbox) return;
    const userCountry = (window.Shopify && window.Shopify.country) || '';
    if (STRICT_CONSENT_COUNTRIES.indexOf(userCountry) !== -1) {
      marketingCheckbox.checked = false;
    } else {
      marketingCheckbox.checked = true;
    }
  }

  applyGeoConsentDefault();

  let submissionInFlight = false;
  let pendingDownloadUrl = null;

  function getCurrentVariantData() {
    return window.WMB_DOWNLOADS[variantInput.value];
  }

  function updateButtons() {
    const data = getCurrentVariantData();
    const showDownloadButton =
      data &&
      Number(data.price) === 0 &&
      data.downloadUrl &&
      data.downloadUrl.length > 0;
    const isFreePrice = data && Number(data.price) === 0;

    if (showDownloadButton) {
      downloadButton.style.display = 'block';
      document.body.classList.add('wmb-free-active');
      if (addToCartButton) addToCartButton.classList.add('wmb-add-to-cart-outline');
    } else {
      downloadButton.style.display = 'none';
      document.body.classList.remove('wmb-free-active');
      if (addToCartButton) addToCartButton.classList.remove('wmb-add-to-cart-outline');
    }

    if (isFreePrice) {
      document.body.classList.add('wmb-free-price');
    } else {
      document.body.classList.remove('wmb-free-price');
    }
  }

 function openPopup() {
  popup.classList.remove('wmb-popup--closed');
  document.body.style.overflow = 'hidden';

  // Re-apply geo-based consent default in case it was changed earlier.
  applyGeoConsentDefault();

  setTimeout(function () {
    if (form) {
      const emailInput = document.getElementById('wmb-email');
      if (emailInput) {
        emailInput.focus();
        emailInput.blur();
      }
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
      document.dispatchEvent(new CustomEvent('shopify:section:reorder'));
    }
    console.log('After popup open, window.hcaptcha is:', typeof window.hcaptcha);
  }, 300);
}

  function closePopup() {
    popup.classList.add('wmb-popup--closed');
    document.body.style.overflow = '';
  }

  function triggerDownload(url) {
    const a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    a.setAttribute('download', '');
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  downloadButton.addEventListener('click', function () {
    openPopup();
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  if (form) {
    form.addEventListener('submit', function (event) {
      const data = getCurrentVariantData();
      const purpose = purposeSelect ? purposeSelect.value : '';

      if (!purpose) {
        event.preventDefault();
        alert('Please select how you will use the map.');
        return;
      }

      if (!data || !data.downloadUrl) {
        event.preventDefault();
        alert('Download file is not available.');
        return;
      }

      if (tagsInput) {
        tagsInput.value = purpose + ', ' + data.productTag;
      }
      if (marketingHidden && marketingCheckbox) {
        marketingHidden.value = marketingCheckbox.checked ? 'true' : 'false';
      }

      submissionInFlight = true;
      pendingDownloadUrl = data.downloadUrl;

      if (messageEl) {
        messageEl.hidden = false;
        messageEl.textContent = 'Preparing your download…';
      }
    });
  }

  if (submitFrame) {
    submitFrame.addEventListener('load', function () {
      if (!submissionInFlight) return;
      submissionInFlight = false;

      if (messageEl) {
        messageEl.textContent = 'Thanks! Your download is starting…';
      }

      if (pendingDownloadUrl) {
        triggerDownload(pendingDownloadUrl);
        pendingDownloadUrl = null;
      }

      setTimeout(function () {
        closePopup();
        if (messageEl) {
          messageEl.hidden = true;
          messageEl.textContent = '';
        }
      }, 1500);
    });
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('select') ||
      event.target.matches('input[type="radio"]') ||
      event.target.matches('[name="id"]')
    ) {
      setTimeout(updateButtons, 100);
    }
  });

  document.addEventListener('variant:change', function () {
    setTimeout(updateButtons, 100);
  });

  updateButtons();
})();